<script setup lang="ts">
import ListBanner from '@components/ui/hotel&view/ListBanner.vue';
import { LoadingStatus } from '@itinerary/ItineraryModuleTypes';
import { ReserveType } from '@utils/itinerary';

const itineraryStore = useItineraryStore();
const searchFormStore = useSearchFormStore();
const contentStore = useContentStore();
const siteConfigs = useSiteConfigs();
const currentModule = useCurrentItineraryModule();

const gtm = useGtm();
const router = useRouter();
const route = useRoute();
const { isMobile } = useSize();
const show = computed(() => {
    const option = itineraryStore.alternativePackageSets[ReserveType.Taxi];
    return (
        currentModule.value.currentLoadingStatus === LoadingStatus.Success &&
        option
    );
});
const banner = computed(() => {
    if (!siteConfigs.showBanners) {
        return null;
    }
    return (
        contentStore.taxiBanners
            .filter(b => new RegExp(b.urlPattern || '').test(route.path))
            .filter(
                m =>
                    !m.displaySize ||
                    m.displaySize === 'both' ||
                    (m.displaySize === 'mobile'
                        ? isMobile.value
                        : !isMobile.value)
            )[0] ?? null
    );
});
const showTaxi = () => {
    gtm?.trackEvent({ event: 'taxi-offer-card-click' });
    const option = itineraryStore.alternativePackageSets[ReserveType.Taxi];
    if (!option) {
        return;
    }
    searchFormStore.shareItineraryInfo(ReserveType.Taxi);
    searchFormStore.setReserveType(ReserveType.Taxi);
    router.replace({
        path: option.url ?? '',
    });
};
</script>
<template>
    <div
        v-if="show && banner"
        id="taxi-offer-card"
        class="taxi-offer-root-container"
    >
        <ListBanner
            :key="banner.id"
            class="taxi-banner"
            :banner
            @click="showTaxi"
        />
    </div>
</template>

<style lang="scss" scoped>
.taxi-banner {
    cursor: pointer;
}
</style>
